import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};
const SideBarTitle = ({ children }: Props) => {
  return <div styleName="sidebar-title ">{children}</div>;
};

export default SideBarTitle;
